import React, { Dispatch, SetStateAction, useState } from "react";
import toast from "react-hot-toast";
import { useAppSelector } from "@/redux/hooks/hooks";
import SingleSelector from "@/components/ui/SingleSelector";
import { TOption } from "@/types/types";
import { useAddCompetitorMutation } from "@/redux/feature/product/productApi";
import { useParams } from "react-router-dom";

interface FormData {
  // brand: string;
  // product: string;
  // country: string;
  comp_name: string;
  fb_url: string;
  ig_username: string;
}

interface ManualCompetitorModalProps {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const initialForm: FormData = {
  // brand: "",
  // product: "",
  // country: "",
  comp_name: "",
  fb_url: "",
  ig_username: "",
};

// Country options data
const countryOptions: TOption[] = [
  {
    id: "IN",
    title: "India",
  },
  {
    id: "US",
    title: "United States",
  },
  {
    id: "GB",
    title: "United Kingdom",
  },
  {
    id: "CA",
    title: "Canada",
  },
  {
    id: "AU",
    title: "Australia",
  },
];

const ManualCompetitorModal: React.FC<ManualCompetitorModalProps> = ({
  setIsOpen,
}) => {
  const [formData, setFormData] = useState<FormData>(initialForm);
  const [selectedCountry, setSelectedCountry] = useState<TOption | undefined>(
    undefined
  );
  const [errors, setErrors] = useState<Partial<FormData>>({});
  const [addCompetitor, { isLoading, isError }] = useAddCompetitorMutation();

  const { user } = useAppSelector((state) => state.auth);

  console.log(isError);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name as keyof FormData]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  // const handleCountryChange = (selected: TOption | undefined) => {
  //   setSelectedCountry(selected);
  //   setFormData((prev) => ({
  //     ...prev,
  //     country: selected ? selected.id : "",
  //   }));

  //   if (errors.country) {
  //     setErrors((prev) => ({ ...prev, country: undefined }));
  //   }
  // };

  const validate = () => {
    const newErrors: Partial<FormData> = {};
    // if (!formData.brand.trim()) newErrors.brand = "Required";
    // if (!formData.product.trim()) newErrors.product = "Required";
    // if (!formData.country.trim()) newErrors.country = "Required";
    if (!formData.comp_name.trim()) newErrors.comp_name = "Required";
    if (!formData.fb_url.trim()) newErrors.fb_url = "Required";
    if (!formData.ig_username.trim()) newErrors.ig_username = "Required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const { brandName, productName, country, productId } = useParams();

  const handleAdd = async () => {
    if (!validate()) return;

    const payload = {
      brand: brandName,
      product: productName,
      product_id: productId,
      country: country,
      comp_name: formData.comp_name,
      fb_url: formData.fb_url,
      ig_username: formData.ig_username,
      email: user?.email,
    };

    console.log(payload);

    try {
      await addCompetitor(payload).unwrap();
      setIsOpen(false);
      toast.success("Competitor added!");
      setFormData(initialForm);
      setSelectedCountry(undefined);
    } catch (err) {
      console.error("Add competitor error:", err);
      toast.error("Failed to add competitor");
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-black">Add Competitor</h2>
        <p className="text-gray-600 text-sm mt-1">
          Fill in the competitor details
        </p>
      </div>

      {/* <div className="w-full gap-4">
        <div>
          <label className="block text-sm font-medium text-black mb-2">
            Brand *
          </label>
          <input
            type="text"
            name={"brand"}
            value={formData.brand}
            onChange={handleChange}
            className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-1 ${
              errors.brand
                ? "border-red-500 ring-red-500"
                : "border-gray-300 focus:border-black focus:ring-black"
            }`}
            placeholder={"Zara"}
          />
          {errors.brand && (
            <p className="text-red-500 text-xs mt-1">
              {errors.brand as string}
            </p>
          )}
        </div>
      </div>

      <div className="w-full gap-4">
        <div>
          <label className="block text-sm font-medium text-black mb-2">
            Product *
          </label>
          <input
            type="text"
            name={"product"}
            value={formData.product}
            onChange={handleChange}
            className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-1 ${
              errors.product
                ? "border-red-500 ring-red-500"
                : "border-gray-300 focus:border-black focus:ring-black"
            }`}
            placeholder={"Shirts"}
          />
          {errors.product && (
            <p className="text-red-500 text-xs mt-1">
              {errors.product as string}
            </p>
          )}
        </div>
      </div>

      <div className="w-full">
        <label className="block text-sm font-medium text-black mb-2">
          Country *
        </label>
        <div className="w-full">
          <SingleSelector
            name="country"
            data={selectedCountry}
            options={countryOptions}
            onChange={handleCountryChange}
          />
        </div>
        {errors.country && (
          <p className="text-red-500 text-xs mt-1">{errors.country}</p>
        )}
      </div> */}

      <div>
        <label className="block text-sm font-medium text-black mb-2">
          Competitor Name *
        </label>
        <input
          type="text"
          name={"comp_name"}
          value={formData.comp_name}
          onChange={handleChange}
          className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-1 ${
            errors.comp_name
              ? "border-red-500 ring-red-500"
              : "border-gray-300 focus:border-black focus:ring-black"
          }`}
          placeholder={"H&M"}
        />
        {errors.comp_name && (
          <p className="text-red-500 text-xs mt-1">{errors.comp_name}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-black mb-2">
          Facebook URL *
        </label>
        <input
          type="text"
          name={"fb_url"}
          value={formData.fb_url}
          onChange={handleChange}
          className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-1 ${
            errors.fb_url
              ? "border-red-500 ring-red-500"
              : "border-gray-300 focus:border-black focus:ring-black"
          }`}
          placeholder={"https://facebook.com/hm"}
        />
        {errors.fb_url && (
          <p className="text-red-500 text-xs mt-1">{errors.fb_url}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-black mb-2">
          Instagram Username *
        </label>
        <input
          type="text"
          name={"ig_username"}
          value={formData.ig_username}
          onChange={handleChange}
          className={`w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-1 ${
            errors.ig_username
              ? "border-red-500 ring-red-500"
              : "border-gray-300 focus:border-black focus:ring-black"
          }`}
          placeholder={"hm"}
        />
        {errors.ig_username && (
          <p className="text-red-500 text-xs mt-1">{errors.ig_username}</p>
        )}
      </div>

      <div className="flex gap-3 pt-6 border-t">
        <button
          onClick={() => setIsOpen(false)}
          disabled={isLoading}
          className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={handleAdd}
          disabled={isLoading}
          className="flex-1 px-6 py-3 bg-black text-white rounded-md hover:bg-gray-800 flex items-center justify-center"
        >
          {isLoading ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2"></div>
              Adding...
            </>
          ) : (
            "Add Competitor"
          )}
        </button>
      </div>
    </div>
  );
};

export default ManualCompetitorModal;
